import { useEffect, useState } from "react";
import { feature } from "topojson-client";

const TOPO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

let cache = null;
let pending = null;

/**
 * Loads and caches the world-atlas topojson, returning an array of GeoJSON country features.
 * Each feature has properties.id = ISO numeric (string, may or may not be padded).
 */
export function useWorldFeatures() {
  const [features, setFeatures] = useState(cache);

  useEffect(() => {
    if (cache) return;
    if (!pending) {
      pending = fetch(TOPO_URL)
        .then((r) => r.json())
        .then((topo) => {
          const fc = feature(topo, topo.objects.countries);
          // Normalize id to padded 3-digit string
          const feats = fc.features.map((f) => ({
            ...f,
            properties: { ...(f.properties || {}), id: String(f.id).padStart(3, "0") },
          }));
          cache = feats;
          return feats;
        });
    }
    pending.then((f) => setFeatures(f));
  }, []);

  return features;
}
